module.exports = __webpack_public_path__ + "static/media/004 I GUERRA M_Caserma san Marco.a3f90ae3.svg";